const locale = {
    placeholder: 'Wagty saýlaň',
    rangePlaceholder: ['Başlanýan wagty', 'Gutarýan wagty'],
};
export default locale;
